import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNav from "../components/sidenav";
import DataTable from "react-data-table-component";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, NavLink } from "react-router-dom";
import { format, parseISO } from "date-fns";

const OrderDetails = () => {

    const { id } = useParams();
    const formatDate = (dateString) => {
        if (!dateString) return ''; // Handle the case when dateString is undefined or null

        const [datePart] = dateString.split('T'); // Split at the 'T' to separate date from time
        const [year, month, day] = datePart.split('-'); // Split date into year, month, and day
        return `${day}/${month}/${year}`; // Format the date as dd/MM/yyyy
    };
    const [orderDetails, setOrderDetails] = useState({
        billingAddress: '',
        billingCity: '',
        billingState: '',
        billingCountry: '',
        billingZipCode: '',
        shippingAddress: '',
        shippingCity: '',
        shippingState: '',
        shippingCountry: '',
        shippingZipCode: '',
        // Additional fields as needed
    });
    const [productDetails, setProductDetails] = useState([]);

    // Function to Fetch data from API for dropdown
    const fetchData = useCallback(async (url, setData) => {

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        if (id) {

            fetchData(`https://igapi.heuristticminds.com/api/OrderList/Get-GetOrderShippingDetailsByOrderID?order_ID=${id}`, setOrderDetails);
            fetchData(`https://igapi.heuristticminds.com/api/OrderList/Get-GetOrderProductDetailsByOrderID?order_ID=${id}`, setProductDetails);
        }
    }, [id, fetchData]);


    const baseColumns1 = [
        {
            name: "Perticular",
            selector: row => (
                <>
                    {row.productName} <br /> {row.categoryType} <br /> {row.size} <br /> {row.artistName} <br /> MRP: {row.mrp} {row.discRate > 0 && `(${row.discRate}%)`}
                </>
            ),
            width: "250px"

        },
        {
            name: "Image",
            cell: (row) => <img className="m-2" src={`../images/products/full/${row.imageURL}`} alt=" " width="80px" />,
            width: "110px"
        },
        {
            name: "HSN Code",
            selector: row => row.hsnCode,
            width: "80px"
        },
        {
            name: "Price",
            selector: row => row.price,
            width: "80px"
        },
        {
            name: "Qty",
            selector: row => row.quantity,
            width: "80px"
        },

    ];

    const CustomHeader = ({ column }) => (
        <div>
            <div>{column.name}</div>
            <div>{column.percentage}</div>
        </div>
    );
    const taxColumns = orderDetails.gstCode === "07" ? [
        {
            name: "CGST",
            selector: row => row.cgst,
            width: "80px",
            percentage: "6%",
            header: CustomHeader
        },
        {
            name: "SGST",
            selector: row => row.sgst,
            width: "80px",
            percentage: "6%",
            header: CustomHeader
        }
    ] : [
        {
            name: "IGST",
            selector: row => row.igst,
            width: "80px",
            percentage: "12%",
            header: CustomHeader
        }
    ];
    const baseColumns2 = [
        {
            name: "Total",
            selector: row => row.gstPrice,
            width: "80px"
        },
        {
            name: "Action",
            cell: (row) => <>

                <button style={{ width: "110px" }} className={`btn m-1 ${row.cancelStatus === 0 ? 'btn-success' : 'btn-danger'} tp`} onClick={(event) => OnCancelClick(event, row.id, row.productName, row.cancelStatus)}>

                    <span className="tptitle">
                        {row.cancelStatus === 0 ? "Cancel Product" : "Canceled Product"}
                    </span>
                    <i className="bi bi-x"></i>
                    &nbsp;<small>{row.cancelStatus === 0 ? "Cancel" : "Canceled"}</small>
                </button>
            </>
        },

    ];
    // Combine the columns
    const columns = [...baseColumns1, ...taxColumns, ...baseColumns2];

    const calculateSubtotals = () => {
        const subtotals = {
            total: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            shippingCost: 0,
            shippingCostGST: 0
        };

        productDetails.forEach(product => {
            subtotals.total += product.gstPrice;  // Assuming `gstPrice` is the total price including GST
            subtotals.cgst += product.cgst || 0;
            subtotals.sgst += product.sgst || 0;
            subtotals.igst += product.igst || 0;
            subtotals.shippingCost += product.shippingCost || 0;
            subtotals.shippingCostGST += product.shippingCostGST || 0;
        });

        return subtotals;
    };

    const { total, cgst, sgst, igst, shippingCost, shippingCostGST } = calculateSubtotals();

    const TableFooter = ({ total, cgst, sgst, igst }) => (
        <div className="row">
            <div className="col"><b>Total: </b>{total.toFixed(2)}</div>
            <div className="col"><b>CGST: </b>{cgst.toFixed(2)}</div>
            <div className="col"><b>SGST: </b>{sgst.toFixed(2)}</div>
            <div className="col"><b>IGST: </b>{igst.toFixed(2)}</div>
        </div>
    );

    const OnCancelClick = async (event, id, item, cancelStatus) => {


        const confirmed = window.confirm(`Are you sure you want to ${cancelStatus === 0 ? "Cancel - " : "alter cancellation - "} ${item} ?`);


        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {

            const response = await fetch('https://igapi.heuristticminds.com/api/OrderList/Update-CancelProductOrderStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                //fetchData('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetCurrencyDetails', setDataCurrency);
            }
        }
        catch {
        }
    }

    return (

        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Order' icon='bi bi-activity' />
                    {orderDetails ? (
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4">
                                        <div className="card-header">Order Details</div>
                                        <div className="card-body">
                                            <NavLink className="btn btn-primary float-end" to={'/orders'}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                            <NavLink className="btn btn-light float-end me-3"><i className="bi bi-pencil-square"></i> Edit Order</NavLink>
                                            <div className="clearfix"></div>
                                            <form>
                                                <div className="p-4 pt-2">
                                                    <div className="row mb-3">
                                                        <div className="col-sm-6">
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Payment Mode : </label>
                                                                <label>{orderDetails.paymentMode}</label>
                                                            </h5>
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Payment Status : </label>
                                                                <label>{orderDetails.paymentStatus}</label>
                                                            </h5>
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Currency : </label>
                                                                <label>{orderDetails.currency}</label>
                                                            </h5>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Order No : </label>
                                                                <label>{orderDetails.orderNo}</label>
                                                            </h5>
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Date : </label>
                                                                <label>{formatDate(orderDetails.createdOn)}</label>
                                                            </h5>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="bdrbox">
                                                                <h4>Bill To</h4>
                                                                <p><label>Name: </label>{orderDetails.billBuyerName}</p>
                                                                <p><label>Billing Address: </label>{orderDetails.billAddress}</p>
                                                                <p><label>City:</label>{orderDetails.billArea}</p>
                                                                <p><label>State:</label>{orderDetails.billState}</p>
                                                                <p><label>Country:</label>{orderDetails.billCountry}</p>
                                                                <p><label>PIN/ZIP Code:</label>{orderDetails.billZIP}</p>
                                                                <p><label>Contact No:</label>{orderDetails.billMobile}</p>
                                                                <p><label>Email ID:</label>{orderDetails.billEmail}</p>
                                                                <p><label>GSTIN:</label>{orderDetails.gstin}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="bdrbox">
                                                                <h4>Ship To</h4>
                                                                <p><label>Name: </label>{orderDetails.shipBuyerName}</p>
                                                                <p><label>Shipping Address: </label>{orderDetails.shipAddress}</p>
                                                                <p><label>City:</label>{orderDetails.shipArea}</p>
                                                                <p><label>State:</label>{orderDetails.shipState}</p>
                                                                <p><label>Country:</label>{orderDetails.shipCountry}</p>
                                                                <p><label>PIN/ZIP Code:</label>{orderDetails.shipZIP}</p>
                                                                <p><label>Contact No:</label>{orderDetails.shipMobile}</p>
                                                                <p><label>Email ID:</label>{orderDetails.shipEmail}</p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <div className="bdrbox">
                                                                <DataTable
                                                                    columns={columns}
                                                                    data={productDetails}
                                                                />
                                                                <hr />
                                                                <TableFooter total={total} cgst={cgst} sgst={sgst} igst={igst} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <div className="bdrbox">
                                                                <p><label>Shipping Charges : </label>{shippingCost.toFixed(2)}</p>
                                                                <p><label>GST on Shipping (18%) : </label>{shippingCostGST.toFixed(2)}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>




                    ) : (
                        // Render a loading indicator or some placeholder while waiting for data
                        <div>Loading...</div>
                    )}

                    <Footer />
                </div>
            </div>
        </>

    )
};
export default OrderDetails;